// @ts-nocheck
import { Map, Placemark, YMaps } from "react-yandex-maps";

import styled from "styled-components";

type TOnChangeReturn = {
    target: {
        value: {
            lat: number;
            lng: number;
        };
    };
};

const MapInput = (props: { value: any; onChange: (value: any) => TOnChangeReturn }) => {
    const { value, onChange = () => {} } = props;
    return (
        <Wrapper>
            <YMaps>
                <Map
                    width={480}
                    height={480}
                    defaultState={{ center: [value.lat ? +value.lat : 55.75, value.lng ? +value.lng : 37.57], zoom: 9 }}
                    onClick={(x: any, y: any) => {
                        const [lat_, lng_] = x.get("coords");
                        onChange({
                            target: {
                                value: {
                                    lat: +lat_,
                                    lng: +lng_,
                                },
                            },
                        });
                    }}
                >
                    <Placemark geometry={[value.lat ? +value.lat : 55.75, value.lng ? +value.lng : 37.57]} />
                </Map>
            </YMaps>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    width: 480px;
    height: 480px;
`;

export default MapInput;
